import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { MichiganOutgoingTitleDto, MichiganOutgoingTitleQueryParams } from 'dtos/michiganOutgoingTitles'
import { MichiganOutgoingTitlesParameters } from 'parameters/michiganOutgoingTitlesParameters'
import { URIQuery } from 'utils'

export const getMichiganOutgoingTitleGroups = (queryParams: MichiganOutgoingTitleQueryParams) =>
  apiClient.get<ApiResponse<MichiganOutgoingTitleDto[]>>(`/api/michigan-outgoing-titles` + URIQuery(queryParams)).then(response => response.data)

export const getMichiganOutgoingTitleGroup = (michiganOutgoingTitleGuid: string) =>
  apiClient
    .get<ApiResponse<MichiganOutgoingTitleDto>>(`/api/michigan-outgoing-titles/${encodeURIComponent(michiganOutgoingTitleGuid)}`)
    .then(response => response.data)

export const createMichiganOutgoingTitleGroup = (values: MichiganOutgoingTitleDto) =>
  apiClient.post<ApiResponse<MichiganOutgoingTitleDto>>(`/api/michigan-outgoing-titles`, values).then(response => response.data)

export const updateMichiganOutgoingTitleGroup = (values: MichiganOutgoingTitleDto) =>
  apiClient.put<ApiResponse<MichiganOutgoingTitleDto>>(`/api/michigan-outgoing-titles`, values).then(response => response.data)

export const deleteMichiganOutgoingTitleGroup = (michiganOutgoingTitleGuid: string) =>
  apiClient.delete<ApiResponse<void>>(`/api/michigan-outgoing-titles/${encodeURIComponent(michiganOutgoingTitleGuid)}`).then(response => response.data)

export const getMichiganOutgoingTitleGroupVehicles = (michiganOutgoingTitleGuid: string, parameters: MichiganOutgoingTitlesParameters) =>
  apiClient
    .get<ApiResponse<MichiganOutgoingTitleDto[]>>(
      `/api/michigan-outgoing-titles/${encodeURIComponent(michiganOutgoingTitleGuid)}/vehicles` + URIQuery({ ...parameters })
    )
    .then(response => response.data)

export const addVehiclesToMichiganOutgoingTitleGroup = (michiganOutgoingTitleGuid: string, values: MichiganOutgoingTitleDto[]) =>
  apiClient
    .post<ApiResponse<MichiganOutgoingTitleDto>>(`/api/michigan-outgoing-titles/${encodeURIComponent(michiganOutgoingTitleGuid)}/vehicles`, values)
    .then(response => response.data)

export const removeVehiclesFromMichiganOutgoingTitleGroup = (michiganOutgoingTitleGuid: string, values: MichiganOutgoingTitleDto[]) =>
  apiClient
    .delete<ApiResponse<MichiganOutgoingTitleDto>>(`/api/michigan-outgoing-titles/${encodeURIComponent(michiganOutgoingTitleGuid)}/vehicles`, { data: values })
    .then(response => response.data)

export const lockMichiganOutgoingTitleGroup = (michiganOutgoingTitleGuid: string) =>
  apiClient
    .put<ApiResponse<MichiganOutgoingTitleDto>>(`/api/michigan-outgoing-titles/${encodeURIComponent(michiganOutgoingTitleGuid)}/lock`)
    .then(response => response.data)

export const unlockMichiganOutgoingTitleGroup = (michiganOutgoingTitleGuid: string) =>
  apiClient
    .put<ApiResponse<MichiganOutgoingTitleDto>>(`/api/michigan-outgoing-titles/${encodeURIComponent(michiganOutgoingTitleGuid)}/unlock`)
    .then(response => response.data)
